import { render, staticRenderFns } from "./AOPTarget.vue?vue&type=template&id=4acf0856&scoped=true"
import script from "./AOPTarget.vue?vue&type=script&lang=js"
export * from "./AOPTarget.vue?vue&type=script&lang=js"
import style0 from "./AOPTarget.vue?vue&type=style&index=0&id=4acf0856&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf0856",
  null
  
)

export default component.exports